module.exports = __webpack_public_path__ + "static/media/better_graph_resized.bcae013a.png";